import springCenfApi from '../../services/springCenfApi'

export const getTicketHints = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/ticket_hints', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getTicketHint = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/ticket_hints/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeTicketHint = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/ticket_hints', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateTicketHint = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/ticket_hints/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteTicketHint = id => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/ticket_hints/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)